import * as React from "react";
import { getPrePacksPrefix, PrePacksLazyRenderContext } from "../helpers";
import { LazyRender } from "../LazyRender";
import { PrePacksLazyRenderContainerWithRef } from "../PrePacksLazyRenderContainer";
//Todo to be extract on lib - https://jira.dkcorpit.com/browse/SB-24657
export class PrePacksLazyRender extends React.Component {
    constructor() {
        super(...arguments);
        this.state = {
            baseMinHeight: this.props.childrenLength * this.props.childMinHeight
        };
        this.containerRef = React.createRef();
        this.templateBaseClass = getPrePacksPrefix("lazyRenderContainer");
        this.setHeight = () => {
            if (this.containerRef.current) {
                this.setState({
                    baseMinHeight: this.containerRef.current.offsetHeight
                });
            }
        };
    }
    render() {
        const { baseMinHeight } = this.state;
        const { children } = this.props;
        return (React.createElement(PrePacksLazyRenderContext.Provider, { value: {
                setHeight: this.setHeight,
            } },
            React.createElement(LazyRender, { baseMinHeight: baseMinHeight, observerOptions: this.props.observerOptions },
                React.createElement(PrePacksLazyRenderContainerWithRef, { ref: this.containerRef }, children))));
    }
}
//# sourceMappingURL=PrePacksLazyRender.js.map